export const pushGaData = (data) => {
    if (!window.dataLayer) {
        console.warn('No dataLayer defined');
    }
    else {
        const resolved = {
            event: data.event || 'AutoEvent',
            eventCategory: data.eventCategory || 'Navigation',
            eventAction: data.eventAction,
            eventLabel: data.eventLabel,
        };
        window.dataLayer.push(resolved);
    }
};
//# sourceMappingURL=GaDataUtil.js.map